import { Typography } from '@mui/material';
import React, { Fragment } from 'react';

const { useState, useEffect, useRef } = React;
import estilos from './FormularioDocumentacion.module.css';



const FormularioDocumentacion = (props) => {
    const data = props.data
    console.log("data en formulario es ", data)
    //DATOS PARA GENERAR DOCUMENTACIÓN DE CONTRATOS
    const [numeroDeCliente, setNumeroDeCliente] = useState('');
    const [datosDelActa, setdatosDelActa] = useState('');
    const [objetoSocial, setObjetoSocial] = useState('');
    const [tipoDeIdentificacion, setTipoDeIdentificacion] = useState('');
    const [otroTipoDeIdentificacion, setOtroTipoDeIdentificacion] = useState('');
    const [numeroDeIdentificacion, setNumeroDeIdentificacion] = useState('');
    const [emisionDeAcreditacion, setEmisionDeAcreditacion] = useState('');
    const [expedidoPor, setExpedidoPor] = useState('');
    const password = data.passwordNom
    const [passwordNomSi, setPasswordNomSi] = useState('');
    const [passwordNomNo, setPasswordNomNo] = useState('');
    const [passwordNom, setPasswordNom] = useState('');
    const [numeroSolicitud, setNumeroSolicitud] = useState('');
    const [numCertificadoNOM, setNumCertificadoNOM] = useState('');
    const [numeroTraslado, setNumeroTraslado] = useState('');
    const [otrosServicios, setOtrosServicios] = useState('');
    const [fechaInspeccion, setFechaInspeccion] = useState('');
    const [numeroPlanEvaluacion, setNumeroPlanEvaluacion] = useState('');
    const [inspectorAsignado, setInspectorAsignado] = useState('');
    const [credencialInspector, setCredencialInspector] = useState('');
    const [telefonoInspector, setTelefonoInspector] = useState('');

    const zeroFill = (number) => {
        let width = 4
        width -= number.length
        if (width > 0) {
            return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
        }
        return number + "";
    }

    const botonAceptar = () => {
        let numCliente = numeroDeCliente
        if (numCliente.length < 5) numCliente = zeroFill(numCliente)
        if (data.regimenfiscal === 'Persona fisica') {
            const data = {
                numeroDeCliente: numCliente, tipoDeIdentificacion, numeroDeIdentificacion, otroTipoDeIdentificacion, emisionDeAcreditacion,
                numeroSolicitud, numCertificadoNOM, numeroTraslado, otrosServicios, fechaInspeccion, numeroPlanEvaluacion,
                inspectorAsignado, credencialInspector, telefonoInspector,
            }
            if (password) {
                data.passwordNom = passwordNom
                data.passwordNomSi = passwordNomSi
                data.passwordNomNo = passwordNomNo
            }
            props.functionAcept(data)
        } else {
            const data = {
                numeroDeCliente: numCliente, tipoDeIdentificacion, numeroDeIdentificacion, datosDelActa, objetoSocial, otroTipoDeIdentificacion, emisionDeAcreditacion,
                numeroSolicitud, numCertificadoNOM, numeroTraslado, otrosServicios, fechaInspeccion, numeroPlanEvaluacion,
                inspectorAsignado, credencialInspector, telefonoInspector,
            }
            if (password) {
                data.passwordNom = passwordNom
                data.passwordNomSi = passwordNomSi
                data.passwordNomNo = passwordNomNo
            }
            props.functionAcept(data)
        }
    }
    let viverista = ''
    let envasador = ''
    let productormaguey = ''
    let productormezcal = ''
    let comercializadormezcal = ''
    let comercializadorbebidasconmezcal = ''
    let cadena = ''
    if (data.viverista === true) cadena += 'Viverista'
    if (data.viverista && (data.envasador || data.productormaguey || data.productormezcal ||
        data.comercializadormezcal || data.comercializadorbebidasconmezcal)) cadena += ','

    if (data.productormaguey === true) cadena += 'Productor maguey'
    if (data.productormaguey && (data.productormezcal || data.envasador ||
        data.comercializadormezcal || data.comercializadorbebidasconmezcal)) cadena += ','

    if (data.productormezcal === true) cadena += 'Productor mezcal'
    if (data.productormezcal && (data.envasador || data.comercializadormezcal || data.comercializadorbebidasconmezcal)) cadena += ','

    if (data.envasador === true) cadena += 'Envasador'
    if (data.envasador && (data.comercializadormezcal || data.comercializadorbebidasconmezcal)) cadena += ','

    if (data.comercializadormezcal === true) cadena += 'Comercializador mezcal'
    if (data.comercializadormezcal && data.comercializadorbebidasconmezcal) cadena += ','

    if (data.comercializadorbebidasconmezcal === true) cadena += 'Comercializador de bebidas con mezcal'

    let arregloCadena = cadena.split(',')
    let combinacionCadena = ''
    let contador = 1
    for (const i in arregloCadena) {
        if (arregloCadena.length === 1) {
            combinacionCadena += arregloCadena[i]
        } else {
            if (arregloCadena.length === (contador + 1)) {
                combinacionCadena += arregloCadena[i] + ' y '
                contador++
            } else {

                combinacionCadena += arregloCadena[i]
                if (arregloCadena.length !== contador) {
                    combinacionCadena += ', '
                }
                contador++
            }

        }

    }
    return (
        <Fragment>

            {/*<div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                <h5 className='label-dark text-center'>Información del solicitante</h5>
                <p className='label-dark'>
                    <b>Nombre o Razón Social:</b>{data.razonsocial}<br />
                    <b>Domicilio Fiscal:</b>{data.calle}{','}{data.numerointerior}{','}{data.numeroexterior}{','}{data.colonia}{','}{data.municipio}{','}{data.localidad}{','}{data.estado}{','}{data.codigopostal}<br />
                    <b>Actividad:</b> 
                    {combinacionCadena} <br />
                    { data.regimenfiscal !== 'Persona fisica' &&
                        <><b>Representante Legal:</b> {data.representantelegal}<br /></>
                    }
                    <b>Teléfonos:</b> {data.telefono}
                </p>
            </div>*/}
            {
                data.regimenfiscal === 'Persona fisica' ?
                    (
                        <Fragment>
                            {/*<div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => (e.target.value).length < 5 ? setNumeroDeCliente(e.target.value) : ''}
                                    value={numeroDeCliente}
                                    placeholder='Número de Asociado' />
                                <label className="floatingInput">Número de Asociado</label>
                            </div>*/}
                            {(!data.solicitud.actualizacioninstalaciones || data?.solicitud?.cambiorazon) &&
                                <Fragment>
                                    <div className={`form-floating mb-2 ${tipoDeIdentificacion === 'OTRO' ? 'col-md-6' : 'col-md-12'}`}>
                                        <div className="form-floating mb-3">
                                            <select className={`form-control`}
                                                value={tipoDeIdentificacion}
                                                onChange={e => setTipoDeIdentificacion(e.target.value)}
                                                id="floatingInput" >
                                                <option value="">Seleccione una opción</option>
                                                <option value={`INE`}>INE</option>
                                                <option value={`IFE`}>IFE</option>
                                                <option value={`PASAPORTE`}>PASAPORTE</option>
                                                <option value={`CÉDULA PROFESIONAL`}>CÉDULA PROFESIONAL</option>
                                                <option value={`OTRO`}>OTRO</option>
                                            </select>
                                            <label className="floatingInput">Tipo de identificación</label>
                                        </div>
                                    </div>
                                    {tipoDeIdentificacion === 'OTRO' &&
                                        <div className='col-md-6'>
                                            <div className="form-floating mb-2">
                                                <input type="text" className={`form-control`}
                                                    onChange={e => setOtroTipoDeIdentificacion(e.target.value)}
                                                    value={otroTipoDeIdentificacion}
                                                    id="" />
                                                <label className="floatingInput">Especifique</label>
                                            </div>
                                        </div>
                                    }
                                    <div className="form-floating mb-3">
                                        <input type="text" id="floatingInput" className={`form-control`}
                                            onChange={e => setNumeroDeIdentificacion(e.target.value)}
                                            value={numeroDeIdentificacion}
                                            placeholder='Número de Identificación' />
                                        <label className="floatingInput">Número de identificación</label>
                                    </div>
                                    <div className="form-floating mb-3">
                                        <input type="text" id="floatingInput" className={`form-control`}
                                            onChange={e => setEmisionDeAcreditacion(e.target.value)}
                                            value={emisionDeAcreditacion}
                                            placeholder='Número de Identificación' />
                                        <label className="floatingInput">Emisión de acreditación</label>
                                    </div>
                                    {(password && !data.solicitud.actualizaciondomicilio || data?.solicitud?.cambiorazon) &&
                                        <Fragment>
                                            <div className='row'>
                                                <div className='col-md-5'>
                                                    <label className="floatingInput">Desea generar una contraseña NOM?</label>
                                                </div>
                                                <div className="form-floating mb-3 col-md-3">
                                                    <input type="checkbox" id="floatingInput" className={`form-check-input me-1`}
                                                        onChange={e => {
                                                            setPasswordNomSi(e.target.checked)
                                                            setPasswordNomNo(false)
                                                        }}
                                                        checked={passwordNomSi} />
                                                    <label className="floatingInput">Si</label>
                                                </div>
                                                <div className="form-floating mb-3 col-md-3">
                                                    <input type="checkbox" id="floatingInput" className={`form-check-input me-1`}
                                                        onChange={e => {
                                                            setPasswordNomNo(e.target.checked)
                                                            setPasswordNomSi(false)
                                                        }}
                                                        checked={passwordNomNo} />
                                                    <label className="floatingInput">No</label>
                                                </div>
                                            </div>

                                            {passwordNomSi &&
                                                <div className="form-floating mb-3">
                                                    <input type="text" id="floatingInput" className={`form-control`}
                                                        onChange={e => setPasswordNom(e.target.value)}
                                                        value={passwordNom}
                                                        placeholder='Contraseña NOM' />
                                                    <label className="floatingInput">Contraseña NOM</label>
                                                </div>}

                                        </Fragment>
                                    }
                                </Fragment>
                            }

                            {data.hacerFormatos === true &&
                                <div> <hr />
                                    <h6 className='text-center'>SOLICITUD DE SERVICIOS DE INSPECCIÓN</h6>
                                    <div className='row justify-content-start mb-2 text-center'>
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setNumeroSolicitud(e.target.value)}
                                                    value={numeroSolicitud}
                                                    placeholder='No. de solicitud' />
                                                <label className="floatingInput">No. de solicitud</label>
                                            </div>
                                        </div>
                                        {data?.solicitud?.cambiorazon != true &&
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                <div className="form-floating mb-3">
                                                    <input type="text" id="floatingInput" className={`form-control`}
                                                        onChange={e => setNumCertificadoNOM(e.target.value)}
                                                        value={numCertificadoNOM}
                                                        placeholder='No. Certificado NOM vigente' />
                                                    <label className="floatingInput">No. Certificado NOM vigente</label>
                                                </div>
                                            </div>
                                        }
                                        {/*<div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setNumeroTraslado(e.target.value)}
                                                    value={numeroTraslado}
                                                    placeholder='Número de traslado' />
                                                <label className="floatingInput">Número de traslado</label>
                                            </div>
                                        </div>*/}
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setOtrosServicios(e.target.value)}
                                                    value={otrosServicios}
                                                    placeholder='Otros servicios' />
                                                <label className="floatingInput">Otros servicios</label>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="date" className={`form-control`}
                                                    onChange={e => setFechaInspeccion(e.target.value)}
                                                    value={fechaInspeccion} name="fechadenacimiento"
                                                    placeholder='Fecha de inspección' />
                                                <label className="floatingInput">Fecha de inspección</label>
                                            </div>
                                        </div>
                                    </div> <hr />
                                    <h6 className='text-center'>PLAN DE EVALUACIÓN</h6>
                                    <div className='row justify-content-start mb-2 text-center'>
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setNumeroPlanEvaluacion(e.target.value)}
                                                    value={numeroPlanEvaluacion}
                                                    placeholder='No. Plan de evaluación' />
                                                <label className="floatingInput">No. del plan de evaluación</label>
                                            </div>

                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setInspectorAsignado(e.target.value)}
                                                    value={inspectorAsignado}
                                                    placeholder='Inspector asignado' />
                                                <label className="floatingInput">Inspector asignado</label>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setCredencialInspector(e.target.value)}
                                                    value={credencialInspector}
                                                    placeholder='Credencial' />
                                                <label className="floatingInput">Credencial del inspector</label>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setTelefonoInspector(e.target.value)}
                                                    value={telefonoInspector}
                                                    placeholder='Teléfono del inspector' />
                                                <label className="floatingInput">Teléfono del inspector</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                        </Fragment>
                    ) :
                    <Fragment>

                        {/*<div className="form-floating mb-3">
                            <input type="text" id="floatingInput" className={`form-control`}
                                onChange={e => (e.target.value).length < 5 ? setNumeroDeCliente(e.target.value) : ''}
                                value={numeroDeCliente}
                                placeholder='Número de Asociado' />
                            <label className="floatingInput">Número de Asociado</label>
                        </div>*/}
                        {(!data.solicitud.actualizacioninstalaciones || data?.solicitud?.cambiorazon) &&
                            <Fragment>
                                <div className='row justify-content-center'>
                                    <div className={`${tipoDeIdentificacion === 'OTRO' ? 'col-md-6' : 'col-md-12'}`}>
                                        {/* <select className={`form-select ${anexoMap.length > 0 ? 'inputValidado' : ''}`} */}
                                        <div className="form-floating mb-3">
                                            <select className={`form-control`}
                                                value={tipoDeIdentificacion}
                                                onChange={e => setTipoDeIdentificacion(e.target.value)}
                                                id="floatingInput"
                                            >
                                                <option value="">Seleccione una opción</option>
                                                <option value={`INE`}>INE</option>
                                                <option value={`IFE`}>IFE</option>
                                                <option value={`PASAPORTE`}>PASAPORTE</option>
                                                <option value={`CÉDULA PROFESIONAL`}>CÉDULA PROFESIONAL</option>
                                                <option value={`OTRO`}>OTRO</option>
                                            </select>
                                            <label className="floatingInput">Tipo de identificación</label>
                                        </div>
                                    </div>

                                    {
                                        tipoDeIdentificacion === 'OTRO' &&
                                        <div className='col-md-6'>
                                            <div className="form-floating mb-2">
                                                <input type="text" className={`form-control`}
                                                    onChange={e => setOtroTipoDeIdentificacion(e.target.value)}
                                                    value={otroTipoDeIdentificacion}
                                                    id="" />
                                                <label className="floatingInput">Especifique</label>
                                            </div>
                                        </div>
                                    }
                                </div>

                                <div className="form-floating mb-3">
                                    <input type="text" id="floatingInput" className={`form-control`}
                                        onChange={e => setNumeroDeIdentificacion(e.target.value)}
                                        value={numeroDeIdentificacion}
                                        placeholder='Número de Identificación' />
                                    <label className="floatingInput">Número de identificación</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="text" id="floatingInput" className={`form-control`}
                                        onChange={e => setEmisionDeAcreditacion(e.target.value)}
                                        value={emisionDeAcreditacion}
                                        placeholder='Número de Identificación' />
                                    <label className="floatingInput">Emisión de acreditación</label>
                                </div>
                                {data.solicitud.tipoempresa != 'fisica' &&
                                    <Fragment>
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setdatosDelActa(e.target.value)}
                                                value={datosDelActa}
                                                placeholder='Datos del Acta Constitutiva' />
                                            <label className="floatingInput">Datos del Acta Constitutiva</label>

                                        </div>

                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setObjetoSocial(e.target.value)}
                                                value={objetoSocial}
                                                placeholder='Objeto Social' />
                                            <label className="floatingInput">Objeto Social</label>
                                        </div>
                                    </Fragment>
                                }


                                {/* <div className="form-floating mb-3">
                                        <input type="text" id="floatingInput" className={`form-control`} 
                                        onChange={e => setExpedidoPor(e.target.value)}
                                        value={expedidoPor}
                                        placeholder='Expedido por' />                        
                                        <label className="floatingInput">Expedido por:</label>
                                    </div> */}
                                {
                                    (password && !data.solicitud.actualizaciondomicilio || data?.solicitud?.cambiorazon) &&
                                    <Fragment>
                                        <div className='row'>
                                            <div className='col-md-5'>
                                                <label className="floatingInput">Desea generar una contraseña NOM?</label>
                                            </div>
                                            <div className="form-floating mb-3 col-md-3">
                                                <input type="checkbox" id="floatingInput" className={`form-check-input me-1`}
                                                    onChange={e => {
                                                        setPasswordNomSi(e.target.checked)
                                                        setPasswordNomNo(false)
                                                    }}
                                                    checked={passwordNomSi} />
                                                <label className="floatingInput">Si</label>
                                            </div>
                                            <div className="form-floating mb-3 col-md-3">
                                                <input type="checkbox" id="floatingInput" className={`form-check-input me-1`}
                                                    onChange={e => {
                                                        setPasswordNomNo(e.target.checked)
                                                        setPasswordNomSi(false)
                                                    }}
                                                    checked={passwordNomNo} />
                                                <label className="floatingInput">No</label>
                                            </div>
                                        </div>

                                        {passwordNomSi &&
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setPasswordNom(e.target.value)}
                                                    value={passwordNom}
                                                    placeholder='Contraseña NOM' />
                                                <label className="floatingInput">Contraseña NOM</label>
                                            </div>}

                                    </Fragment>
                                }
                            </Fragment>
                        }
                        {
                            data.hacerFormatos === true &&
                            <div>
                                <hr />
                                <h6 className='text-center'>SOLICITUD DE SERVICIOS DE INSPECCIÓN</h6>
                                <div className='row justify-content-start mb-2 text-center'>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setNumeroSolicitud(e.target.value)}
                                                value={numeroSolicitud}
                                                placeholder='No. de solicitud' />
                                            <label className="floatingInput">No. de solicitud</label>
                                        </div>
                                    </div>
                                    {data?.solicitud?.cambiorazon != true &&
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setNumCertificadoNOM(e.target.value)}
                                                    value={numCertificadoNOM}
                                                    placeholder='No. Certificado NOM vigente' />
                                                <label className="floatingInput">No. Certificado NOM vigente</label>
                                            </div>
                                        </div>
                                    }
                                    {/*<div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setNumeroTraslado(e.target.value)}
                                                value={numeroTraslado}
                                                placeholder='Número de traslado' />
                                            <label className="floatingInput">Número de traslado</label>
                                        </div>
                                    </div>*/}
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setOtrosServicios(e.target.value)}
                                                value={otrosServicios}
                                                placeholder='Otros servicios' />
                                            <label className="floatingInput">Otros servicios</label>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="date" className={`form-control`}
                                                onChange={e => setFechaInspeccion(e.target.value)}
                                                value={fechaInspeccion}
                                                placeholder='Fecha de inspección' />
                                            <label className="floatingInput">Fecha de inspección</label>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <h6 className='text-center'>PLAN DE EVALUACIÓN</h6>
                                <div className='row justify-content-start mb-2 text-center'>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setNumeroPlanEvaluacion(e.target.value)}
                                                value={numeroPlanEvaluacion}
                                                placeholder='No. Plan de evaluación' />
                                            <label className="floatingInput">No. del plan de evaluación</label>
                                        </div>

                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setInspectorAsignado(e.target.value)}
                                                value={inspectorAsignado}
                                                placeholder='Inspector asignado' />
                                            <label className="floatingInput">Inspector asignado</label>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setCredencialInspector(e.target.value)}
                                                value={credencialInspector}
                                                placeholder='Credencial' />
                                            <label className="floatingInput">Credencial del inspector</label>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setTelefonoInspector(e.target.value)}
                                                value={telefonoInspector}
                                                placeholder='Teléfono del inspector' />
                                            <label className="floatingInput">Teléfono del inspector</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </Fragment>
            }
            <Typography id="modal-modal-description" sx={{ mt: 2 }} className='text-center'>
                Está a punto de aceptar la solicitud, ya no podrá seguir revisándola
                y los datos se tomarán como válidos.<br /> <strong>¿Desea continuar?</strong>
            </Typography>
            <div className='row'>
                <button className='btn btn-success' onClick={() => botonAceptar()}>CONTINUAR</button>
            </div>
        </Fragment>
    );
};

export default FormularioDocumentacion;
